import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Chip } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

/**
 * Mode Switch Button
 * 
 * Super admin only button to switch between Admin and Clinical modes
 * - Shows "Admin Tools" when on clinical routes → goes to /admin
 * - Shows "Back to Clinic" when on admin routes → goes to last clinical route
 */
const ModeSwitchButton = () => {
  const { isSuperAdmin } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  
  // Only show for super admins
  if (!isSuperAdmin) return null;
  
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isClinicalRoute = location.pathname.startsWith('/clinic-dashboard') || 
                          location.pathname.startsWith('/clinic-staff-dashboard') ||
                          location.pathname.startsWith('/physician') ||
                          location.pathname.startsWith('/dashboard') ||
                          location.pathname.startsWith('/sponsor-dashboard');
  
  const handleClick = () => {
    if (isAdminRoute) {
      // Go back to last clinical route or default
      const lastClinical = localStorage.getItem('lastClinicalRoute') || '/clinic-dashboard';
      navigate(lastClinical);
    } else if (isClinicalRoute) {
      // Save current route before switching
      localStorage.setItem('lastClinicalRoute', location.pathname);
      navigate('/admin');
    }
  };
  
  // Only show if we're in a relevant route
  if (!isAdminRoute && !isClinicalRoute) return null;
  
  return (
    <Chip
      icon={isAdminRoute ? <ArrowBackIcon fontSize="small" /> : <AdminPanelSettingsIcon fontSize="small" />}
      label={isAdminRoute ? 'Back to Clinic' : 'Admin Tools'}
      onClick={handleClick}
      color={isAdminRoute ? 'default' : 'primary'}
      variant="outlined"
      sx={{ 
        cursor: 'pointer',
        color: 'white',
        borderColor: 'rgba(255, 255, 255, 0.5)',
        '&:hover': {
          borderColor: 'white',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
        '& .MuiChip-icon': {
          color: 'white',
        },
      }}
    />
  );
};

export default ModeSwitchButton;
